module.exports = __webpack_public_path__ + "static/media/emma_inscripcion_cierre_preuniversitario.aba093d0.png";